module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/hero-75c3e863f84856710158741bd73997d3.jpg";